import {
    FETCH_PRACTICE_INCOME_REQUEST,
    FETCH_PRACTICE_INCOME_SUCCESS,
    FETCH_PRACTICE_INCOME_FAILURE,
  } from "./FetchPracticeIncomeTypes";
  import api from "../../utils/Api";
  
  export const fetchPracticeIncomeRequest = () => {
    return {
      type: FETCH_PRACTICE_INCOME_REQUEST,
    };
  };
  
  export const fetchPracticeIncomeSuccess = (practiceIncome) => {
    return {
      type: FETCH_PRACTICE_INCOME_SUCCESS,
      payload: practiceIncome,
    };
  };
  
  export const fetchPracticeIncomeFailure = (error) => {
    return {
      type: FETCH_PRACTICE_INCOME_FAILURE,
      payload: error,
    };
  };
  
  export const fetchPracticeIncome = (sortBy, page, view_by, practitioner_id) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "/report/practiceincome/fetch?sort_by="+sortBy + "&page="+ page;

    if(view_by === "month"){
        url += "&month="+ 1;
    }
    if(view_by === "week"){
        url += "&week="+ 1;
    }
    if(practitioner_id){
        url += "&practitioner_id="+ practitioner_id;
    }
    
    return async (dispatch) => {
      dispatch(fetchPracticeIncomeRequest());
      try {
        const response = await api.get(url,
          {
            headers: headers,
          }
        );
        const practiceIncome = response.data.data;
        //console.log("****** practice Income response", practiceIncome);
        dispatch(fetchPracticeIncomeSuccess(practiceIncome));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchPracticeIncomeFailure(errorMsg));
      }
    };
  };
  